/**
 * The connection indicator's state from what the health check has seen (CLAUDE.md §3.3.5). Owner,
 * 2026-10-07: the indicator must never say «متصل» before the first real check — it used to start
 * as "online" and stayed so for as long as the first check took (30 s seen under heavy load on a
 * PC). Until the server has answered once, the state is "checking".
 */
export type ConnectionState = 'checking' | 'online' | 'offline' | 'serverDown';

export interface HealthCheckFacts {
  /** The browser's own view (navigator.onLine). */
  readonly browserOnline: boolean;
  /** When the last answer arrived (ms); 0: never. */
  readonly answeredAt: number;
  /** When the last check failed — no answer, an error or its time limit (ms); 0: never. */
  readonly failedAt: number;
  /** The last answer was not a health report (a status other than 200 / 503). */
  readonly answerUnusable: boolean;
}

export function connectionState(facts: HealthCheckFacts): ConnectionState {
  if (!facts.browserOnline) return 'offline';
  // The last answer counts until a new one arrives: a check running again after a failure is
  // still "server down", never "online".
  if (facts.failedAt > facts.answeredAt) return 'serverDown';
  if (facts.answeredAt === 0) return 'checking';
  return facts.answerUnusable ? 'serverDown' : 'online';
}

/** "Server away" for the screens that offer working without it: only a real answer says so. */
export function serverAway(state: ConnectionState): boolean {
  return state === 'offline' || state === 'serverDown';
}
